import InitialState from '../initial-state';
import * as ActionName from '../action-names';
import { ActionTypes } from '../app-data/actions';

export default function liveRightNowReducer(state = InitialState.getState().liveRightNow, action) {
  switch (action.type) {
    case ActionName.LIVE_RIGHT_NOW_DATA_LOAD_SUCCESS: {
      const id = action.payload && action.payload.length ? action.payload[0].id : null;
      return {
        ...state,
        activeSportId: state.activeSportId ? state.activeSportId : id,
        sportIdsWithEventList: action.payload
      };
    }
    case ActionName.LIVE_RIGHT_NOW_CHANGE_ACTIVE_SPORT: {
      return {
        ...state,
        activeSportId: action.id
      };
    }
    case ActionTypes.ADD_LIVE_EVENT: {
      const { eventDetails, sport } = action.payload;
      const eventId = eventDetails.event.id;
      const sportId = sport.id;
      const sportIdsWithEventList = [...state.sportIdsWithEventList];
      const sportIndex = sportIdsWithEventList.findIndex(sport => sport.id === sportId);
      if (sportIndex > -1) {
        sportIdsWithEventList[sportIndex].eventIds.push(eventId);
      } else {
        sportIdsWithEventList.push({ id: sportId, eventIds: [eventId] });
      }

      return {
        ...state,
        sportIdsWithEventList: sportIdsWithEventList
      };
    }
    case ActionTypes.REMOVE_EVENT: {
      const eventId = action.payload;
      const sportIdsWithEventList = [...state.sportIdsWithEventList];
      sportIdsWithEventList.forEach(sport => {
        sport.eventIds = sport.eventIds.filter(id => id !== eventId);
      });

      return {
        ...state,
        sportIdsWithEventList: sportIdsWithEventList
      };
    }
    default:
      return state;
  }
}
